// Canonical look for "demoed" (marked-for-demolition) hatching, shared across
// the floorplan (2D canvas), 3D (CanvasTexture), and elevations (SVG) renderers
// so the demo indication stays visually consistent everywhere.
export const DEMOED_HATCH_COLOR = '#990000'; // default red
export const DEMOED_HATCH_COLOR_EMPHASIS = '#CC0000'; // selected/emphasis red
export const DEMOED_HATCH_ANGLE_DEG = 45;
